module.exports = __webpack_public_path__ + "2f5603d929d0c123494874c23e369e3c.pdf";